import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import Popover from "@isomorphic/shared/isomorphic/components/uielements/popover";
import IntlMessages from "@isomorphic/shared/isomorphic/components/utility/intlMessages";
import notification from "@isomorphic/shared/isomorphic/components/Notification";
import AuthAction from "../../redux/auth/actions";
import DashboardAction from "../../redux/dashboard/actions";
import userpic from "@isomorphic/shared/isomorphic/assets/images/user1.png";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import DashboardSettingsModal from "./topbarDashboardSettingsModal";

const UserSettingsModal = React.lazy(() => import("./topbarUserSettingsModal"));

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      limitFields: {},
      limitFieldgroups: {},
      showSettingsModal: false,
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.user !== prevProps.user) {
      this.setState({
        selectedUser: {},
        saveType: {},
        loading: false,
        showSettingsModal: false,
      });
      notification("success", `Your profile has been updated successfully`);
    }
  }

  hide() {
    this.setState({ visible: false });
  }

  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  userUpdate = (updatedUser) => {
    this.setState({
      loading: true,
    });
    this.props.apiSettingsUpdate(updatedUser);
  };

  showUserUpdate = (e) => {
    let selectedUser = {
      ID: this.props.user.ID,
      Picture: this.props.user.Picture,
      Signature: this.props.user.Signature,
      UserPassword: this.props.user.UserPassword,
    };

    this.setState({
      selectedUser: selectedUser,
      visible: false,
      saveType: "update",
      showSettingsModal: true,
    });
  };

  hideUserModal = () => {
    this.setState({
      selectedUser: {},
      saveType: {},
      showSettingsModal: false,
    });
  };

  showDashboardUpdate = (e) => {
    this.setState({
      visible: false,
      showDashboardModal: true,
    });
  };

  userDashboardUpdate = (headerKeys, contentKeys) => {
    this.props.apiWidgetsUpdate(headerKeys, contentKeys);
    this.setState({
      showDashboardModal: false,
    });
  };

  hideDashboardModal = () => {
    this.setState({
      showDashboardModal: false,
    });
  };

  render() {
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <a className="isoDropdownLink" onClick={this.showUserUpdate} href="# ">
          <IntlMessages id="themeSwitcher.settings" />
        </a>
        <a className="isoDropdownLink" onClick={this.props.logout} href="# ">
          <IntlMessages id="topbar.logout" />
        </a>
      </TopbarDropdownWrapper>
    );
    return (
      <>
        <Popover
          content={content}
          trigger="click"
          visible={this.state.visible}
          onVisibleChange={this.handleVisibleChange}
          arrowPointAtCenter={true}
          placement="bottomLeft"
        >
          <Row style={{ paddingTop: "10px" }}>
            {this.props.app.view === "DesktopView" && (
              <Col style={{ paddingRight: "20px", paddingTop: "5px" }}>
                {(this.props.user.NameFirst || this.props.user.NameLast) &&
                <Row>
                  <span style={{ color: "white" }}>
                    {this.props.user.NameFirst} {this.props.user.NameLast}
                  </span>
                </Row>}
                <Row>
                  <small style={{ color: "grey" }}>
                    {this.props.user.UserID}
                  </small>
                </Row>
              </Col>
            )}
            <Col sm={4}>
              <div className="isoImgWrapper">
                {this.props.user.Picture ? (
                  <img
                    alt="user"
                    className={"topbar-user-icon"}
                    src={"data:image/png;base64," + this.props.user.Picture}
                  />
                ) : (
                  <img
                    src={userpic}
                    className={"topbar-user-icon"}
                    alt="user"
                  />
                )}
                <span className="userActivity online" />
              </div>
            </Col>
          </Row>
        </Popover>
        <React.Suspense fallback={""}>
          <UserSettingsModal
            title={"Settings"}
            selectedUser={this.state.selectedUser}
            visible={this.state.showSettingsModal}
            loading={this.state.loading}
            onCancel={this.hideUserModal}
            onSubmit={this.userUpdate}
            submitText={"Save"}
          />
        </React.Suspense>
        <DashboardSettingsModal
          title={"Dashboard Settings"}
          visible={this.state.showDashboardModal}
          loading={this.state.loading}
          onCancel={this.hideDashboardModal}
          onSubmit={this.userDashboardUpdate}
          submitText={"Save"}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({
    app: state.App,
    user: state.Auth.user,
    fields: state.User.fields,
    fieldgroups: state.User.fieldgroups,
  }),
  { ...AuthAction, ...DashboardAction }
)(TopbarUser);
